import { useLocation } from 'react-router-dom';
import useStore from '../../Hooks/useStore';
import { useSnackbar } from 'notistack';
import { useAbility } from '../../Hooks/useAbility';

const useValidityController = () => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
    validity: { getFormMessage, getValidity },
  } = getters;
  const {
    modal: { setModal },
    validity: {
      filterProducts,
      validateForm,
      setValidity,
      autocompleteProducts,
      filterBranches,
      createValidity,
      createValidityStatus,
      updateValidity,
      updateValidityStatus,
      filterValidities,
      deleteValidities,
      deleteValidityStatus,
      autocompleteValidities,
      autocompleteValidityStatus,
      filterCompleteValidities,
      filterValidityStatus,
      filterValidityStatusValidity,
    },
  } = setters;
  const location = useLocation();
  const currentRoute = location.pathname;
  const { enqueueSnackbar } = useSnackbar();
  const { Can, ability } = useAbility();

  return {
    getModal,
    setModal,
    location,
    currentRoute,
    enqueueSnackbar,
    Can,
    ability,
    filterProducts,
    validateForm,
    getFormMessage,
    getValidity,
    setValidity,
    autocompleteProducts,
    filterBranches,
    createValidity,
    createValidityStatus,
    filterValidities,
    deleteValidities,
    deleteValidityStatus,
    autocompleteValidities,
    autocompleteValidityStatus,
    updateValidity,
    updateValidityStatus,
    filterCompleteValidities,
    filterValidityStatus,
    filterValidityStatusValidity,
  };
};

export default useValidityController;
